<div class="dialog">
  <mat-dialog-content>
    <div mat-dialog-title>Morningstar Categories Automatic Mapping</div>
    <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
      <mat-card class="block warn">
        <mat-card-title style="white-space: pre-line;">
          Enable automatic mapping: {{securitiesExisting}}
        </mat-card-title>
      </mat-card>
      <div [innerHTML]="modalDescription" style="line-height: normal;letter-spacing: normal;"></div>
    </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="continue()" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
</div>
